const recruiterLiteProfile = [
    { attribute: 'id', element: 'experience-card' }, // Contact Page
];
const recruiterLiteBulk = [
    { attribute: 'class', element: 'profile-list-item hp-core-temp' }, // Bulk Search Page
];
export const LINKEDIN_RECRUITER_LITE_LEGACY_INDICATORS_BY_CONTEXT_TYPE = {
    profile: recruiterLiteProfile,
    bulk: recruiterLiteBulk,
    unknown: [...recruiterLiteProfile, ...recruiterLiteBulk],
};
